(function () {
  function toArray(nodeList) {
    return Array.prototype.slice.call(nodeList || []);
  }

  function hasClass(element, className) {
    return element && (' ' + element.className + ' ').indexOf(' ' + className + ' ') > -1;
  }

  function findParentByClass(element, className) {
    var current = element;

    while (current && current !== document) {
      if (hasClass(current, className)) return current;
      current = current.parentNode;
    }

    return null;
  }

  function setClass(element, className, shouldHaveClass) {
    if (!element) return;

    if (element.classList) {
      element.classList.toggle(className, shouldHaveClass);
      return;
    }

    if (shouldHaveClass && !hasClass(element, className)) {
      element.className += ' ' + className;
    } else if (!shouldHaveClass && hasClass(element, className)) {
      element.className = (' ' + element.className + ' ').replace(' ' + className + ' ', ' ').replace(/^\s+|\s+$/g, '');
    }
  }

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return;

    var openDrawer = function () {
      if (typeof drawer.open === 'function') {
        drawer.open();
        return;
      }

      var trigger = drawer.querySelector('[on\\:click="/open"], button');
      if (trigger && typeof trigger.click === 'function') trigger.click();
    };

    if (window.customElements && typeof window.customElements.whenDefined === 'function') {
      window.customElements.whenDefined('cart-drawer-component').then(function () {
        window.requestAnimationFrame(openDrawer);
      });
      return;
    }

    window.requestAnimationFrame(openDrawer);
  }

  function getData(element, key) {
    if (!element) return '';
    if (element.dataset && element.dataset[key]) return element.dataset[key];

    return element.getAttribute('data-' + key.replace(/[A-Z]/g, function (match) {
      return '-' + match.toLowerCase();
    })) || '';
  }

  function setGalleryImage(gallery, index) {
    var mainImage = gallery.querySelector('[data-trp-gallery-main]');
    var counter = gallery.querySelector('[data-trp-gallery-counter]');
    var thumbs = toArray(gallery.querySelectorAll('[data-trp-gallery-index]'));
    var nextThumb = thumbs[index];

    if (!mainImage || !nextThumb) return;

    mainImage.src = getData(nextThumb, 'trpGallerySrc');
    mainImage.alt = getData(nextThumb, 'trpGalleryAlt');

    thumbs.forEach(function (thumb, thumbIndex) {
      var isActive = thumbIndex === index;
      setClass(thumb, 'is-active', isActive);
      thumb.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    if (counter) {
      counter.textContent = (index + 1) + ' / ' + thumbs.length;
    }

    gallery.setAttribute('data-trp-gallery-current', String(index));
  }

  function initGallery(gallery) {
    var thumbs = toArray(gallery.querySelectorAll('[data-trp-gallery-index]'));
    var prev = gallery.querySelector('[data-trp-gallery-prev]');
    var next = gallery.querySelector('[data-trp-gallery-next]');

    if (!thumbs.length) return;

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        setGalleryImage(gallery, index);
      });
    });

    if (prev) {
      prev.addEventListener('click', function () {
        var current = Number(gallery.getAttribute('data-trp-gallery-current') || 0);
        var nextIndex = current <= 0 ? thumbs.length - 1 : current - 1;
        setGalleryImage(gallery, nextIndex);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        var current = Number(gallery.getAttribute('data-trp-gallery-current') || 0);
        var nextIndex = current >= thumbs.length - 1 ? 0 : current + 1;
        setGalleryImage(gallery, nextIndex);
      });
    }

    setGalleryImage(gallery, 0);
  }

  function initVideoCard(card) {
    var video = card.querySelector('video');
    var playButton = card.querySelector('[data-trp-video-play]');

    if (!video || !playButton) return;

    playButton.addEventListener('click', function () {
      if (!video.paused) {
        video.pause();
        setClass(card, 'is-playing', false);
        playButton.setAttribute('aria-label', playButton.getAttribute('data-play-label') || 'Play video review');
        return;
      }

      toArray(document.querySelectorAll('[data-trp-video-card]')).forEach(function (otherCard) {
        var otherVideo = otherCard.querySelector('video');
        var otherPlayButton = otherCard.querySelector('[data-trp-video-play]');

        if (!otherVideo || otherVideo === video) return;

        otherVideo.pause();
        setClass(otherCard, 'is-playing', false);
        if (otherPlayButton) {
          otherPlayButton.setAttribute('aria-label', otherPlayButton.getAttribute('data-play-label') || 'Play video review');
        }
      });

      setClass(card, 'is-playing', true);
      playButton.setAttribute('aria-label', playButton.getAttribute('data-pause-label') || 'Pause video review');

      var playPromise = video.play();

      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {
          setClass(card, 'is-playing', false);
          playButton.setAttribute('aria-label', playButton.getAttribute('data-play-label') || 'Play video review');
        });
      }
    });

    playButton.setAttribute('data-play-label', playButton.getAttribute('aria-label') || 'Play video review');
    playButton.setAttribute('data-pause-label', playButton.getAttribute('aria-label').replace('Play', 'Pause'));

    video.addEventListener('ended', function () {
      setClass(card, 'is-playing', false);
      playButton.setAttribute('aria-label', playButton.getAttribute('data-play-label') || 'Play video review');
    });
  }

  function initPurchaseForm(form) {
    var sectionRoot = findParentByClass(form, 'trp-product-main') || document;
    var sellingPlanInput = form.querySelector('[data-trp-selling-plan-input]');
    var deliveryOptions = toArray(form.querySelectorAll('[data-trp-delivery-option]'));
    var packCards = toArray(sectionRoot.querySelectorAll('[data-trp-pack-card]'));
    var price = form.querySelector('[data-trp-purchase-price]');
    var subcopy = form.querySelector('[data-trp-purchase-subcopy]');
    var recurringRow = form.querySelector('[data-trp-purchase-recurring-row]');
    var recurring = form.querySelector('[data-trp-purchase-recurring]');
    var benefitGroups = toArray(form.querySelectorAll('[data-trp-benefits]'));
    var cta = form.querySelector('[data-trp-purchase-cta]');
    var ctaPrice = form.querySelector('[data-trp-purchase-cta-price]');
    var stickyCta = form.querySelector('[data-trp-sticky-cta]');
    var stickyPrice = form.querySelector('[data-trp-sticky-price]');
    var stickyCtaPrice = form.querySelector('[data-trp-sticky-cta-price]');
    var eligibilityNote = form.querySelector('[data-trp-subscription-eligibility-note]');

    function getRequestedMode() {
      var requestedMode;

      try {
        requestedMode = new URLSearchParams(window.location.search).get('trp_purchase');
      } catch (error) {
        requestedMode = '';
      }

      return requestedMode === 'subscribe' || requestedMode === 'one-time' ? requestedMode : '';
    }

    function addModeToHref(href, mode) {
      var url;

      if (!href || href === '#') return href;

      try {
        url = new URL(href, window.location.origin);
        url.searchParams.set('trp_purchase', mode);
        return url.pathname + url.search + url.hash;
      } catch (error) {
        return href;
      }
    }

    if (!deliveryOptions.length) return;

    function setFieldText(field, text, allowHtml) {
      if (!field) return;

      if (allowHtml) {
        field.innerHTML = text ? text.replace(/\s*\|\s*/g, '<br>') : '';
      } else {
        field.textContent = text ? text.replace(/\s*\|\s*/g, '\n') : '';
      }

      field.hidden = !text;
    }

    function updatePackCards(mode) {
      var modeKey = mode === 'one-time' ? 'oneTime' : 'subscription';

      packCards.forEach(function (card) {
        var isDisabled = getData(card, modeKey + 'Disabled') === 'true';
        var isOneTimeOnly = getData(card, 'trpOneTimeOnly') === 'true';
        var href = addModeToHref(getData(card, modeKey + 'Href'), mode);
        var offer = card.querySelector('[data-trp-pack-field="offer"]');
        var note = getData(card, modeKey + 'Note');
        var divider = card.querySelector('[data-trp-pack-field="divider"]');

        card.hidden = isOneTimeOnly && mode !== 'one-time';

        setClass(card, 'is-disabled', isDisabled);
        card.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');

        if (isDisabled || !href) {
          card.removeAttribute('href');
          card.setAttribute('tabindex', '-1');
        } else {
          card.setAttribute('href', href);
          card.removeAttribute('tabindex');
        }

        setFieldText(card.querySelector('[data-trp-pack-field="badge"]'), getData(card, modeKey + 'Badge'));
        setFieldText(card.querySelector('[data-trp-pack-field="price"]'), getData(card, modeKey + 'Price'));
        setFieldText(card.querySelector('[data-trp-pack-field="timing"]'), getData(card, modeKey + 'Timing'));
        setFieldText(offer, getData(card, modeKey + 'Offer'));
        setFieldText(card.querySelector('[data-trp-pack-field="compare"]'), getData(card, modeKey + 'Compare'));
        setFieldText(card.querySelector('[data-trp-pack-field="save"]'), getData(card, modeKey + 'Save'));
        setFieldText(card.querySelector('[data-trp-pack-field="note"]'), note, true);

        if (divider) divider.hidden = !note;
        setClass(offer, 'trp-pack-card__offer--muted', isDisabled);
        setClass(offer, 'trp-pack-card__offer--one-time', mode === 'one-time' && !isDisabled);
      });
    }

    function applyOption(option) {
      var sellingPlanId;
      var recurringText;

      if (!option || option.disabled) return;

      sellingPlanId = getData(option, 'sellingPlanId');
      recurringText = getData(option, 'recurring');

      if (sellingPlanInput) {
        sellingPlanInput.value = sellingPlanId;
        sellingPlanInput.disabled = !sellingPlanId;
      }

      deliveryOptions.forEach(function (deliveryOption) {
        setClass(findParentByClass(deliveryOption, 'trp-delivery-card'), 'is-active', deliveryOption === option);
      });

      if (price && getData(option, 'price')) price.textContent = getData(option, 'price');
      if (subcopy && getData(option, 'subcopy')) subcopy.textContent = getData(option, 'subcopy');
      if (recurring) recurring.textContent = recurringText;
      if (recurringRow) recurringRow.hidden = !recurringText;
      if (cta && getData(option, 'cta')) cta.textContent = getData(option, 'cta');
      if (ctaPrice && getData(option, 'price')) ctaPrice.textContent = getData(option, 'price');
      if (stickyCta && getData(option, 'stickyCta')) stickyCta.textContent = getData(option, 'stickyCta');
      if (stickyPrice && getData(option, 'price')) stickyPrice.textContent = getData(option, 'price');
      if (stickyCtaPrice && getData(option, 'price')) stickyCtaPrice.textContent = getData(option, 'price');
      if (eligibilityNote) eligibilityNote.hidden = option.value !== 'subscribe';

      benefitGroups.forEach(function (group) {
        var isActive = getData(group, 'trpBenefits') === option.value;
        group.hidden = !isActive;
        setClass(group, 'is-active', isActive);
      });

      updatePackCards(option.value);
    }

    deliveryOptions.forEach(function (option) {
      var label = findParentByClass(option, 'trp-delivery-card');

      function selectOption() {
        if (option.disabled) return;

        option.checked = true;
        applyOption(option);
      }

      option.addEventListener('change', selectOption);
      option.addEventListener('click', selectOption);

      if (label) {
        label.addEventListener('click', selectOption);
      }
    });

    var requestedMode = getRequestedMode();
    var requestedOption = deliveryOptions.filter(function (option) {
      return option.value === requestedMode && !option.disabled;
    })[0];

    if (requestedOption) {
      deliveryOptions.forEach(function (option) {
        option.checked = option === requestedOption;
      });
    }

    applyOption(deliveryOptions.filter(function (option) {
      return option.checked;
    })[0]);

    form.addEventListener('cart:update', function (event) {
      var detail = event.detail || {};
      var data = detail.data || {};

      if (data.didError || data.source !== 'product-form-component') return;

      openCartDrawer();
    });
  }

  function initStickyAtc(bar) {
    var form = findParentByClass(bar, 'trp-purchase-form');
    var mainCta = form ? form.querySelector('.trp-purchase-card__cta') : null;
    var passOffset = 32;

    function setVisible(isVisible) {
      setClass(bar, 'is-visible', isVisible);
      bar.setAttribute('aria-hidden', isVisible ? 'false' : 'true');

      if (isVisible) {
        bar.removeAttribute('inert');
      } else {
        bar.setAttribute('inert', '');
      }
    }

    function update() {
      var mainCtaRect;

      if (!mainCta) {
        setVisible(false);
        return;
      }

      mainCtaRect = mainCta.getBoundingClientRect();
      setVisible(mainCtaRect.bottom < -passOffset);
    }

    bar.setAttribute('inert', '');

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initFaq(root) {
    var items = toArray(root.querySelectorAll('.trp-faq__item'));

    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;

        items.forEach(function (otherItem) {
          if (otherItem !== item) otherItem.removeAttribute('open');
        });
      });
    });
  }

  function init() {
    toArray(document.querySelectorAll('[data-trp-gallery]')).forEach(initGallery);
    toArray(document.querySelectorAll('[data-trp-video-card]')).forEach(initVideoCard);
    toArray(document.querySelectorAll('.trp-purchase-form')).forEach(initPurchaseForm);
    toArray(document.querySelectorAll('[data-trp-sticky-atc]')).forEach(initStickyAtc);
    toArray(document.querySelectorAll('.trp-faq')).forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
